import Lightbox from 'modules/gallery-lightbox';
import Gallery from 'modules/gallery';
import 'mypage/list';

// non-editable kid mypage stuff
Lightbox.lightboxID = '#mypage_photo_overlay';
Lightbox.photoID = '#mypage_photo_overlay_image';
Lightbox.setup();

Gallery.setup();

// Display Read More button to logged out users if over a certain height
const $storyContent = $('#website_message_content');
const $storyContentHeight = $('#website_message_content').height();
const $readMore = $('#storyReadMore');
const $kidNameContainer = $('.kid__name');
const $kidNameLength = $('.kid-name')[0].textContent;
const $maxHeight = 300;

if ($kidNameLength.length >= 20) {
  $kidNameContainer.addClass('long-kid-name');
} else {
  $kidNameContainer.removeClass('long-kid-name');
}

// Safari Hack - Removing class added to prevent transition from firing on page load
$(window).on('load', function () {
  $storyContent.removeClass('preload-safari');
});

if (!$('.mypage--main').hasClass('mypage--editable')) {
  // if the story is longer than what we say - show button
  if ($storyContentHeight >= $maxHeight) {
    $readMore.show();
    $storyContent.addClass('shortened');
  }

  $readMore.click(function () {
    $storyContent.addClass('expand');
    $readMore.hide();
  });
}

if ($('#honor-list li').length <= 2) {
  $('#honor-list').addClass('column-count-1');
}

// View More Gallery Photos
if (!$('#mypage--main').hasClass('mypage--editable')) {
  $('.view-gallery').click(function () {
    $('#photo-gallery').addClass('photo-gallery__show-all');
    if ($('#photo-gallery li').length === $('#photo-gallery li:visible').length) {
      $('.view-gallery').hide();
    }
  });
}
